import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import styled, { css } from 'styled-components'

import Icon from '../Icon'

export const Container = styled(motion.div)`
  position: relative;
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(32)};
`
export const Slider = styled.div``
type SlideProps = {
  $forcedRatio: boolean
  $breakpoint?: keyof typeof sizes
  $forcedRatioHeight?: number
  $forcedRatioWidth?: number
}
export const Slide = styled.div<SlideProps>`
  ${({ $forcedRatio, $breakpoint, $forcedRatioHeight, $forcedRatioWidth }) =>
    $forcedRatio &&
    css`
      @media ${mq(sizes[$breakpoint ?? 'desktop'])} {
        .keen-slider:not([data-keen-slider-disabled]) &.keen-slider__slide {
          min-width: 0;
          max-width: none;
          flex: 0 0 auto;
          width: ${pxToRem($forcedRatioWidth ?? 100)};
          height: ${pxToRem($forcedRatioHeight ?? 100)};
        }
        .keen-slider:not([data-keen-slider-disabled]) &.keen-slider__slide img {
          height: 100%;
          object-fit: cover;
        }
      }
    `}
`
export const Nav = styled.div<{ $visibleOnDesktop?: boolean }>`
  display: flex;
  align-items: center;
  .keen-slider[data-keen-slider-disabled] ~ & {
    display: none;
  }
  @media ${mq(sizes.desktop)} {
    display: ${({ $visibleOnDesktop }) =>
      $visibleOnDesktop ? 'flex' : 'none'};
    .keen-slider[data-keen-slider-disabled] ~ & {
      display: none;
    }
  }
`
export const Dots = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  gap: ${pxToRem(8)};
  @media ${mq(sizes.desktop)} {
    display: none;
  }
`
export const Dot = styled.button`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(16)};
  height: ${pxToRem(2)};
  background: ${({ theme }) => theme.colors.black};
  opacity: 0.3;
  &[aria-current='true'] {
    width: ${pxToRem(32)};
    opacity: 1;
  }
  & span {
    ${({ theme }) => theme.textStyles.accessibleHiddenText}
  }
`
export const Arrows = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: ${pxToRem(16)};
  margin-inline-start: auto;
  @media ${mq(sizes.desktop)} {
    margin-inline-start: 0;
  }
`
export const Arrow = styled.button`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(32)};
  background: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black};
  &[disabled] {
    pointer-events: none;
    opacity: 0.5;
  }
`
export const ArrowIcon = styled(Icon)`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(24)};
`
export const Numerotation = styled.span`
  ${({ theme }) => theme.textStyles.d1440_button}
  display: none;
  @media ${mq(sizes.desktop)} {
    display: flex;
  }
`
